import RoutesManager from "@/components/admin/RoutesManager";

// Standalone "Global Route Index" — cross-path search / QA shortcut.
// The primary editing surface is Bike Paths -> select path -> Routes tab,
// which embeds the same RoutesManager with a fixed bike path.
export default function RoutesPanel() {
  return <RoutesManager />;
}
